import React, {
  useState,
  useRef,
  useEffect
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Grid,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  ToggleButtonGroup,
  ToggleButton,
  Pagination
} from '@material-ui/lab';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ProjectCard from 'src/components/ProjectCard';
import { TAGS_LIST_API } from 'src/Api/Community/Index';

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    position: 'relative',
    '&:after': {
      position: 'absolute',
      bottom: -8,
      left: 0,
      content: '" "',
      height: 3,
      width: 48,
      backgroundColor: theme.palette.primary.main
    }
  },
  sortButton: {
    textTransform: 'none',
    letterSpacing: 0,
    marginRight: theme.spacing(2)
  }
}));

const Results = ({ className, threads,page,setPage,pageCount,selectedSort,setSelectedSort,threadCount, ...rest }) => {
  const classes = useStyles();
  const sortRef = useRef(null);
  const [openSort, setOpenSort] = useState(false);
  const [mode, setMode] = useState('list');
  const [tags, setTags] = useState([]);    
  
  const [optionsSearch, setOptionsSearch] = useState([
    { value: ' ', label: 'All Thread' },
  ]);
  
  const handleSortOpen = () => {
    setOpenSort(true);
  };

  const handleSortClose = () => {
    setOpenSort(false);
  };

  const handleSortSelect = (value) => {
    // console.log(value);
    setSelectedSort(value);
    setOpenSort(false);
  };

  const handleModeChange = (event, value) => {
    setMode(value);
  };

  const handlePagination=(e,page)=>{
    // console.log(page);
    setPage(page);
  }

  const getTags = (async () => {
    try {       
      const {data}=await TAGS_LIST_API() 
      const {status,tags,message,count}=data;
      if(status){                
        setTags(tags);
      }else{
        console.error(message);          
      }
    } catch (err) {
      console.error(err);
    }
  }); 

  const get_filter_title=(id)=>{
    if(id){
      if(id==="1"){
        return 'Most Recent'
      }else if(id==="2"){
        return 'Popular'
      }else if(id===" "){
        return 'All Thread'
      }else{
        // console.log(tags);
        const tag=tags.filter((el)=>el._id===id);
        if(tag.length>0){
          return tag[0].title;
        }else{
          return 'Filter';
        }
      }
      return 'Filter';
    }else{
      return 'Filter';
    }
  }

  useEffect(() => {
    getTags();
  }, []);

  useEffect(() => {
    const newOptionsSearch = [
      ...optionsSearch,
      ...tags.map((tag) => ({ value: tag._id, label: tag.title })),
    ];
    setOptionsSearch(newOptionsSearch);
  }, [tags]);

  

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        mb={2}
      >
        <Typography
          className={classes.title}
          variant="h5"
          color="textPrimary"
        >
          Showing
          {' '}
          {threadCount??0}
          {' '}
          questions
        </Typography>
        <Box
          display="flex"
          alignItems="center"
        >
          {/* <Button
            className={classes.sortButton}
            onClick={handleSortOpen}
            ref={sortRef}
          >
            {get_filter_title(selectedSort)}
            <ArrowDropDownIcon />
          </Button> */}
          {/* <ToggleButtonGroup
            exclusive
            onChange={handleModeChange}
            size="small"
            value={mode}
          >
            <ToggleButton value="grid">
              <ViewModuleIcon />
            </ToggleButton>           
          </ToggleButtonGroup> */}
        </Box>
      </Box>
      <Grid
        container
        spacing={3}
      >
        {threads.map((thread) => (
          <Grid
            item
            key={thread._id}
            md={mode === 'grid' ? 4 : 12}
            sm={mode === 'grid' ? 6 : 12}
            xs={12}
          >
            <ProjectCard thread={thread} page={page}/>
          </Grid>
        ))}
      </Grid>
      <Box
        mt={6}
        display="flex"
        justifyContent="center"
      >
        <Pagination count={pageCount} onChange={handlePagination}/>
      </Box>
      <Menu
        anchorEl={sortRef.current}
        onClose={handleSortClose}
        open={openSort}
        elevation={1}
      >
        {optionsSearch.map(
          (option) => (
            <MenuItem             
              key={option.value}             
              onClick={() => handleSortSelect(option.value)}
            >
              <ListItemText primary={option.label} />
            </MenuItem>
          )
        )}
      </Menu>
    </div>
  );
}

Results.propTypes = {
  className: PropTypes.string,
  projects: PropTypes.array.isRequired
};

export default Results;
